<template>
  <v-skeleton-loader
    :loading="isLoading"
    transition="expand-transition"
    type="article"
  >
    <FormJobListingStatus
      :JobListingStatus="editJobListingStatus"
      :isSaving="isSaving"
      @save="save"
      @cancel="$router.push({ name: from.name })" />
  </v-skeleton-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import FormJobListingStatus from '../components/FormJobListingStatus.vue';

export default {
  components: {
    FormJobListingStatus,
  },
  name: 'EditJobListingStatus',
  module: 'JobListingStatuses',
  mixins: [loading],
  data() {
    return {
      /**
      * Get/Set editing JobListingStatus. Default to {}.
      */
      editJobListingStatus: {},
      /**
       * Query Id for JobListingStatus
       */
      jobListingStatusId: this.$route?.query.id,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('jobListingStatuses', ['jobListingStatuses', 'jobListingStatus']),
    /** Get the mode for this view, create or update
     */
    mode() {
      if (this.jobListingStatusId) {
        return 'edit';
      }
      return 'add';
    },
  },
  async mounted() {
    this.isLoading = true;
    if (this.mode === 'edit') {
      await this.LOAD_jobListingStatus(this.jobListingStatusId);
      this.editJobListingStatus = this.jobListingStatus;
    }
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('jobListingStatuses', ['LOAD_jobListingStatus', 'CREATE_jobListingStatus', 'UPDATE_jobListingStatus']),
    /** Method used to save the item
     */
    async save(jobListingStatus) {
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_jobListingStatus(jobListingStatus);
      } else {
        await this.UPDATE_jobListingStatus(jobListingStatus);
      }
      this.isSaving = false;
      this.$router.push({ name: 'admin-ListJobListingStatus' });
    },
  },
};
</script>

<docs>
# EditJobListingStatus example

'''js
<EditJobListingStatus :JobListingStatus="JobListingStatus" />
'''
</docs>
